import axios from 'axios';
import moment from 'moment';

import { API_ENDPOINT } from './constants';

const ScenariosAPI = {
  async getScenarios() {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/scenarios`)).data;
      return pld;
    } catch (_exc) { }
    return [];
  },

  async getScenariosPublic() {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/scenarios/public`)).data;
      return pld;
    } catch (_exc) { }
    return [];
  },

  async getScenariosPrivate() {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/scenarios/private`)).data;
      return pld;
    } catch (_exc) { }
    return [];
  },

  async getPublicScenarios() {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/public/scenarios`)).data;
      return pld;
    } catch (_exc) { }
    return [];
  },

  async getScenario(id) {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/scenarios/${id}`)).data;
      return pld;
    } catch (_exc) { }
  },

  async createScenario(data) {
    const revString = `rev-${moment().format('YYYYMMDDHHmmss')}`;
    try {
      const pld = (
        await axios.post(`${API_ENDPOINT}/scenarios`, {
          ...data,
          revision: revString
        })
      ).data;
      return pld;
    } catch (_exc) { }
  },

  async updateScenario(data) {
    try {
      const revString = `rev-${moment().format('YYYYMMDDHHmmss')}`;
      const pld = (
        await axios.put(`${API_ENDPOINT}/scenarios/${data.id}`, {
          ...data,
          revision: revString
        })
      ).data;
      return pld;
    } catch (_exc) { }
  },

  async deleteScenario(id) {
    try {
      const pld = (await axios.delete(`${API_ENDPOINT}/scenarios/${id}`)).data;
      return pld;
    } catch (_exc) { }
  }
};

export default ScenariosAPI;
